/* eslint-disable no-constant-condition */
import React, { useEffect, useState, useContext, useRef } from "react"
import intl from "react-intl-universal"
import FileIcon from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"
import styles from "./index.module.scss"
import Input from "../../../../atoms/Input"
import RcmpCheckBox from "../../../../atoms/Checkbox"
import RcmpHeader from "../../../../atoms/Header"
import "./style.css"
import { TopRelease } from "../../components/TopRelease"
import { TableRelease } from "../../components/TableRelease"
import { IEyeicon } from "../../../../../assets/icons/IEyeicon"
import {
  equipmentAnalyteLaunch,
  postRelease,
  postReleaseAll,
} from "../../../../../services/ciq"
import { useNavigate, useParams } from "react-router-dom"
import RcmpLoading from "../../../../atoms/Loading"
import { set, useForm } from "react-hook-form"
import Button from "../../../../atoms/Button"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"
import { ModalInformation } from "../../components/ModalInformation"
import Select from "../../../../atoms/Select"
import { LaunchAnalysis } from "./components/LaunchAnalysis"
import { NumericFormat } from "react-number-format"
import { AnalyteContextProvider, useAnalyte } from "./context/analyte"
import SwitchComponent from "../../../../atoms/Switch"
import { getAnalyteLaunch } from "../../../../../services/ciq"
import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import { fnCanAtLeast } from "../../../../../utils/permissions"
import {
  fnisOnlyPermition,
  fnMoreThanOnePermition,
  fnIsAccessPermition,
} from "../../../../../utils/verifyPermitions"
import ObservationIcon from "../../../../../assets/icons/FileIcon"
import { Flex } from "@stardust-ds/react"
import ModalObservation from "./components/ModalObservation"
import useDataApi from "../../../../../hooks/useDataApi"

const ANALYTE_LAUNCHS_LIMIT = 10

const ElInputNumber = (props) => {
  return (
    <Input
      autoComplete="off"
      className={styles.inputLevel}
      placeholder="00,00"
      {...props}
    />
  )
}

const ContextRelease = () => {
  return (
    <AnalyteContextProvider>
      <Release />
    </AnalyteContextProvider>
  )
}

const Release = () => {
  const [abreadCrumbs, setABreadCrumbs] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingLaunchAnalysis, setIsLoadingLaunchAnalysis] = useState(false)
  const [order, setOrder] = useState("asc")
  const [obj, setObj] = useState([])
  const [nameEquipment, setNameEquipment] = useState("")
  const [isLoadingButton, setIsLoadingButton] = useState(false)
  const [isCancelModal, setIsCancelModal] = useState(false)
  const [activeTab, setActiveTab] = useState(true)
  const [oPagination, setOPagination] = useState({ page: 1, lastPage: 1 })
  const [oLaunchObservation, setOLaunchObservation] = useState(null)

  const [oReleaseAllRes, fnReleaseAllReq] = useDataApi(postReleaseAll)

  const [filters, setFilters] = useState({
    approved: false,
    no_alert_rejection: true,
    alert: true,
    rejection: true,
  })

  const { id } = useParams()
  const { oUser } = useContext(AuthContext)
  const bAnalyteLaunchsWasLoad = useRef(null) // check if analyte launchs was loaded for the first time

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const navigate = useNavigate()
  const {
    dataAnalyte,
    setDataAnalyte,
    reload,
    setReload,
    launchAnalysis,
    setLaunchAnalysis,
  } = useAnalyte()

  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/ciq",
      name: intl.get("ciq.title"),
    },
    {
      name: nameEquipment,
      bActive: true,
    },
  ]

  const getEquipmentAnalyteLaunch = async (order) => {
    try {
      setIsLoadingLaunchAnalysis(true)
      const response = await equipmentAnalyteLaunch(id, order)

      const results = response.data.data.equipment_analytes.map((objeto) => {
        const { anlt_levels } = objeto
        const elevel1 = anlt_levels.find((level) => level.elevel === 1)
        const elevel2 = anlt_levels.find((level) => level.elevel === 2)
        const elevel3 = anlt_levels.find((level) => level.elevel === 3)

        return { ...objeto, elevel1, elevel2, elevel3 }
      })

      setDataAnalyte(results)

      setNameEquipment(response.data.data.equipment_cname)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingLaunchAnalysis(false)
    }
  }

  const fnGetAnalyteLaunchRuns = async (id, filters, page, order) => {
    if (isLoading) return
    if (page === 1) {
      setLaunchAnalysis([]) // reset list
    }

    try {
      setIsLoading(true)
      const params = `approved=${filters.approved ? "1" : "0"}&no_alert_rejection=${
        filters.no_alert_rejection ? "1" : "0"
      }&alert=${filters.alert ? "1" : "0"}&rejection=${
        filters.rejection ? "1" : "0"
      }&paginate=${ANALYTE_LAUNCHS_LIMIT}&sort_order=${order}&page=${page}`

      const response = await getAnalyteLaunch(id, params)

      const results = response.data.data.equipment_analytes.map((objeto) => {
        const { anlt_levels } = objeto
        const elevel1 = anlt_levels.find((level) => level.elevel === 1)
        const elevel2 = anlt_levels.find((level) => level.elevel === 2)
        const elevel3 = anlt_levels.find((level) => level.elevel === 3)

        return { ...objeto, elevel1, elevel2, elevel3 }
      })

      const resultsLengh = results?.length || 0
      const lastPage = resultsLengh < ANALYTE_LAUNCHS_LIMIT ? page : page + 1

      setOPagination((prev) => ({ ...prev, lastPage: lastPage }))

      if (page === 1) {
        setLaunchAnalysis(filterArray(results))
        return
      }

      setLaunchAnalysis((oldstate) => {
        const arr = [...oldstate, ...results]
        return filterArray(arr)
      })
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
      bAnalyteLaunchsWasLoad.current = true
    }
  }

  function filterArray(array) {
    let uniqueArray = array.filter((item, index) => {
      return array.findIndex((obj) => obj.anlt_nid === item.anlt_nid) === index
    })
    return uniqueArray
  }

  useEffect(() => {
    if (!bAnalyteLaunchsWasLoad.current) return

    fnGetAnalyteLaunchRuns(id, filters, oPagination.page, order)
  }, [order, reload, oPagination.page])

  useEffect(() => {
    if (oPagination.page === 1) {
      fnGetAnalyteLaunchRuns(id, filters, oPagination.page, order)
      return
    }

    setOPagination((prev) => ({ ...prev, page: 1 }))
  }, [filters, order])

  useEffect(() => {
    setABreadCrumbs(aBreadCrumbs)

    getEquipmentAnalyteLaunch(order)
  }, [order, reload])

  useEffect(() => {
    setABreadCrumbs([
      {
        path: "./",
        name: intl.get("home"),
      },
      {
        path: "/ciq",
        name: intl.get("ciq.title"),
      },
      {
        name: nameEquipment,
        bActive: true,
      },
    ])
  }, [dataAnalyte])

  const { handleSubmit } = useForm()

  function filterLastOfEachGroup(arr) {
    const result = []
    const groupMap = {}

    arr.filter((a) => a?.nvalue || a?.resultopt_nid).forEach((item) => {
      const key = `${item.anlt_nid}-${item.elevel}`
      groupMap[key] = item
    })

    Object.keys(groupMap).forEach((key) => {
      result.push(groupMap[key])
    })

    return result
  }
  const onSubmit = async () => {
    if (isLoadingButton) return

    try {
      setIsLoadingButton(true)

      const filteredArray = filterLastOfEachGroup(obj)

      const res = {
        launches: filteredArray,
      }

      await postRelease(id, res)

      setReload(!reload)
      setObj([])
      // setPerPage(1)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadingButton(false)
    }
  }

  const transformDate = (date) => {
    if (!cUserTimeZone) return ""
    const [data, hour] = fnFormatDateFromUTC(
      `${date}`,
      "DD/MM/YYYY - HH:mm",
      cUserTimeZone,
    ).split(" - ")

    return data + " às " + hour
  }

  const redirectToReleaseDetails = (analyteId) => {
    navigate(`/ciq/release/${id}/details/${analyteId}`)
  }

  const fnReleaseAll = async (id) => {
    if (oReleaseAllRes.loading) return
    try {
      await fnReleaseAllReq(id)

      setReload(!reload)
    } catch (err) {
      console.log(err)
    }
  }

  const handleOnInputNumberChange = (e, item, level, oNewValues) => {
    const value = e.value.replace(",", ".")
    if (value === "") {
      // remove item from array
      const filterFields = obj?.filter(
        (o) => o?.anlt_nid !== item?.anlt_nid || o?.elevel !== level?.elevel,
      )

      setObj(filterFields || [])
      return
    }

    setObj((oldstate) => [...oldstate, { ...oNewValues, nvalue: value }])
  }

  const isAccessCreateEditLaunchn = fnIsAccessPermition("create-edit-launch")
  const isAccessApprovedRuns = fnIsAccessPermition("update-run")

  const isOnlyView = !isAccessCreateEditLaunchn
  const isPermition =
    fnisOnlyPermition("access-ciq") || isOnlyView || !isAccessApprovedRuns

  useEffect(() => {
    if (isPermition) {
      return
    } else if (!fnCanAtLeast("create-edit-launch", "internal-quality-control")) {
      if (
        !fnCanAtLeast("create-edit-launch", "internal-quality-control") &&
        (!fnCanAtLeast("access-ciq", "internal-quality-control") ||
          !fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
          !fnCanAtLeast("update-run", "internal-quality-control"))
      ) {
        window.location.href = "/"
        return
      } else if (
        fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
        fnCanAtLeast("create-edit-control", "internal-quality-control") ||
        (fnCanAtLeast("update-run", "internal-quality-control") &&
          !fnCanAtLeast("create-edit-launch", "internal-quality-control"))
      ) {
        window.location.href = "/"
        return
      }
    }

    if (fnCanAtLeast("create-edit-launch", "internal-quality-control")) {
      setActiveTab(false)
      return
    }
  }, [])

  const handleOpenModalObservation = (oLaunch) => {
    setOLaunchObservation(oLaunch)
  }

  const handleCloseModalObservation = () => {
    setOLaunchObservation(null)
  }

  const handleSaveLaunchObservation = (oLaunch) => {
    const oLaunchIndex = obj?.findIndex(
      (o) => o?.anlt_nid === oLaunch.anlt_nid && o?.elevel === oLaunch.elevel,
    )

    if (oLaunchIndex >= 0) {
      const newLaunch = obj.map((item) => {
        if (item.anlt_nid === oLaunch.anlt_nid && item.elevel === oLaunch.elevel) {
          return { ...item, cobservation: oLaunch.cobservation }
        }

        return item
      })

      setObj(newLaunch)

      return
    }

    setObj((oldstate) => [...oldstate, oLaunch])
  }

  return (
    <div>
      <RcmpHeader
        elIcon={<FileIcon />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={abreadCrumbs}
        className={styles.header}
      ></RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bSwitchable={false}
        cIconLeftInsideBtn={<></>}
        bVisibleIconSearch={false}
        cWidthBtn="15rem"
        sButtonLabel={intl.get("ciq.release_all")}
        bArrowLeftGoBack={true}
        bDisableButton={isPermition || oReleaseAllRes.loading}
        fnSetBisOpenModal={
          (() => {
            if (isPermition) return
          },
          (!activeTab) ? () => fnReleaseAll(id) : null)
        }
        cPathGoBack={"/ciq"}
        cLabelGoBack={intl.get("ciq.exame_analyte", { name: nameEquipment })}
        className={styles.contentB1lankCustom}
      >
        <TopRelease
          setOrder={setOrder}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        {isLoadingLaunchAnalysis ? (
          <div className={styles.loading}>
            <RcmpLoading bShow={true} size={50} />
          </div>
        ) : activeTab ? (
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <TableRelease
              thead={[
                "",
                intl.get("ciq.name_analyte"),
                intl.get("ciq.level_one"),
                intl.get("ciq.level_two"),
                intl.get("ciq.level_three"),
              ]}
            >
              {dataAnalyte.map((item, index) => {
                return (
                  <tr key={item.anlt_nid}>
                    <td className={styles.contentButton}>
                      <Button
                        stableIcon
                        variant="outline"
                        iconLeft={<IEyeicon fill="#6CB6E3" />}
                        onClick={() => redirectToReleaseDetails(item.anlt_nid)}
                      >
                        {intl.get("ciq.see_details")}
                      </Button>
                    </td>
                    <td className={styles.contentCname}>
                      <p className={styles.cname}>{item.anlt_cname}</p>

                      <p className={styles.lastUpdate}>{intl.get("ciq.last_release")}</p>
                    </td>
                    {item.anlt_levels.map((level, i) => {
                      let date = ""

                      if (level.launch?.launch_dupdated) {
                        date = transformDate(level.launch?.launch_dupdated)
                      }

                      const bDisabledLevel = !level.bavailable || isOnlyView

                      const dataObj = {
                        anlt_nid: item.anlt_nid,
                        resultopt_nid: null,
                        elevel: level.elevel,
                        nvalue: null,
                        cobservation: null,
                      }

                      const oValue = obj?.find(
                        (o) =>
                          o?.anlt_nid === item.anlt_nid && o?.elevel === level.elevel,
                      )
                      const bHasObservation = oValue?.cobservation

                      return (
                        <td key={level.elevel}>
                          <div className={styles.contentInputs}>
                            {item.anlt_type !==
                            intl.get("ciq.types_analytes.quantitative") ? (
                              <>
                                <Flex
                                  width="100%"
                                  alignItems="center"
                                  justifyContent="flex-start"
                                  gap="8px"
                                >
                                  <Select
                                    autoComplete="off"
                                    disabled={bDisabledLevel}
                                    label=""
                                    options={level.options.map((item) => ({
                                      value: item.resultopt_nid,
                                      label: item.resultopt_cdescription,
                                    }))}
                                    placeholder={intl.get("ciq.select_a_type")}
                                    searchable={false}
                                    width="100%"
                                    className={styles.select}
                                    onSelect={(e) => {
                                      dataObj.resultopt_nid =
                                        e?.value === null ? 0 : e?.value

                                      setObj((oldstate) => [...oldstate, dataObj])
                                    }}
                                  />
                                  <button
                                    type="button"
                                    title={intl.get("ciq.launch_observation.title")}
                                    className={`${styles.observatonButton} ${
                                      bHasObservation ? styles.active : ""
                                    }`}
                                    disabled={bDisabledLevel || !oValue?.resultopt_nid}
                                    onClick={() =>
                                      handleOpenModalObservation(oValue)
                                    }
                                  >
                                    <ObservationIcon />
                                  </button>
                                </Flex>
                                {level.launch?.launch_resultopt_cdescription && date ? (
                                  <p>
                                    {date}
                                    &nbsp;&nbsp;&nbsp;&nbsp; {"•"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span
                                      style={{
                                        color:
                                          level.launch?.launch_resultopt_ecompliance ===
                                          "N"
                                            ? "#FF3541"
                                            : "#000",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {level.launch?.launch_resultopt_cdescription}
                                    </span>
                                  </p>
                                ) : (
                                  <p style={{ visibility: "hidden", opacity: 0 }}>
                                    {date} • <span>12,00</span>
                                  </p>
                                )}
                              </>
                            ) : (
                              <div>
                                <Flex
                                  width="100%"
                                  alignItems="center"
                                  justifyContent="flex-start"
                                  gap="8px"
                                >
                                  <NumericFormat
                                    key={index}
                                    className={styles.inputLevel}
                                    decimalScale={item.anlt_decimal_places}
                                    allowLeadingZeros
                                    fixedDecimalScale
                                    disabled={bDisabledLevel}
                                    style={{
                                      opacity: level.bavailable ? 1 : 0.5,
                                    }}
                                    onValueChange={(e) =>
                                      handleOnInputNumberChange(e, item, level, dataObj)
                                    }
                                    customInput={ElInputNumber}
                                    decimalSeparator=","
                                    placeholder={
                                      "00" +
                                      (item.anlt_decimal_places > 0 ? "," : "") +
                                      "0".repeat(item.anlt_decimal_places)
                                    }
                                  />
                                  <button
                                    type="button"
                                    title={intl.get("ciq.launch_observation.title")}
                                    className={`${styles.observatonButton} ${
                                      bHasObservation ? styles.active : ""
                                    }`}
                                    disabled={bDisabledLevel || !oValue?.nvalue}
                                    onClick={() =>
                                      handleOpenModalObservation(oValue)
                                    }
                                  >
                                    <ObservationIcon />
                                  </button>
                                </Flex>

                                {typeof level.launch?.launch_nvalue === "number" &&
                                date ? (
                                  <p>
                                    {date}
                                    &nbsp;&nbsp;&nbsp;&nbsp; {"•"}
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span
                                      style={{
                                        color:
                                          level.launch?.launch_eaction === "A"
                                            ? "#FFAE00"
                                            : level.launch?.launch_eaction === "R"
                                            ? "#FF3541"
                                            : "#000",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {new Intl.NumberFormat("pt-BR", {
                                        minimumFractionDigits: item.anlt_decimal_places,
                                        maximumFractionDigits: item.anlt_decimal_places,
                                      }).format(level.launch?.launch_nvalue)}
                                    </span>
                                  </p>
                                ) : (
                                  <p style={{ visibility: "hidden", opacity: 0 }}>
                                    23/10/2023 às 15h30 • <span>12,00</span>
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </TableRelease>

            <div className={styles.containerButton}>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  setIsCancelModal(true)
                }}
              >
                {intl.get("ciq.btn_cancel")}
              </Button>
              <Button
                type="submit"
                isLoading={isLoadingButton}
                disabled={obj.length === 0 || isLoadingButton}
              >
                {intl.get("save_cap")}
              </Button>
            </div>
          </form>
        ) : (
          <div className={styles.wrapperGraphic}>
            <div className={styles.wrapperFilter}>
              <SwitchComponent
                width="8.5rem"
                bSingleOption
                onClick={() => {
                  setFilters({ ...filters, approved: !filters.approved })
                }}
                cDisabledText={intl.get("ciq.status_race.approved")}
                value={filters.approved}
                // cAbleText={intl.get("ciq.active_up")}
              />

              <p>Exibir:</p>
              <RcmpCheckBox
                cLabel={intl.get("ciq.no_alert_rejection")}
                bColorLabel
                checked={filters.no_alert_rejection}
                onClick={() =>
                  setFilters({
                    ...filters,
                    no_alert_rejection: !filters.no_alert_rejection,
                  })
                }
              />
              <RcmpCheckBox
                cLabel={intl.get("ciq.with_alerts")}
                bColorLabel
                checked={filters.alert}
                onClick={() =>
                  setFilters({
                    ...filters,
                    alert: !filters.alert,
                  })
                }
              />
              <RcmpCheckBox
                cLabel={intl.get("ciq.with_rejections")}
                bColorLabel
                checked={filters.rejection}
                onClick={() =>
                  setFilters({
                    ...filters,
                    rejection: !filters.rejection,
                  })
                }
              />
            </div>
            <div className={styles.contentIdentify}>
              <p>{intl.get("ciq.name_analyte")}</p>

              <div className={styles.contentLevels}>
                <strong>
                  <div className={styles.circleLevel} style={{ background: "#0066FF" }} />
                  {intl.get("ciq.level_one")}
                </strong>
                <strong>
                  <div className={styles.circleLevel} style={{ background: "#B83EE3" }} />
                  {intl.get("ciq.level_two")}
                </strong>
                <strong>
                  <div className={styles.circleLevel} style={{ background: "#89C22C" }} />
                  {intl.get("ciq.level_three")}
                </strong>
              </div>
            </div>

            <div className={styles.infiniteScrollContainer}>
              <InfiniteScroll
                fnNext={(page) => setOPagination((prev) => ({ ...prev, page: page }))}
                nTotalPages={oPagination?.lastPage}
                nDataLength={launchAnalysis?.length}
                bStopPagination={isLoading}
              >
                {launchAnalysis?.map((item, index) => (
                  <LaunchAnalysis
                    key={item.anlt_cname}
                    anlt_cname={item.anlt_cname}
                    anlt_nid={item.anlt_nid}
                    bg={index % 2 === 0 ? "" : "#f2f5f8"}
                    graph={item.anlt_graph}
                    equipmentId={id}
                    item={item}
                    type={item.anlt_type}
                    runs={item.anlt_runs}
                    idx={index}
                  />
                ))}
              </InfiniteScroll>
            </div>
            <RcmpLoading bShow={isLoading} size={50} />
          </div>
        )}
      </ContentBlank>

      {isCancelModal && (
        <ModalInformation
          bgBtn="#1ECB4F"
          bShow={isCancelModal}
          title={intl.get("ciq.releases")}
          description={intl.get("ciq.changes_not_save")}
          onClose={() => navigate("/ciq")}
          onCancel={() => setIsCancelModal(false)}
        />
      )}

      <ModalObservation
        bIsOpen={!!oLaunchObservation}
        oLaunch={oLaunchObservation}
        onConfirm={handleSaveLaunchObservation}
        onClose={handleCloseModalObservation}
      />
    </div>
  )
}
export default ContextRelease
